// extracted by mini-css-extract-plugin
export default {"divider":"_1gzln3k"};